{
  "locale": "Français",
  "sidebar": {
    "title": "Demande de partage de données",
    "issuanceTitle": "Demande d'ajout de données",
    "authenticationTitle": "Demande d'authentification",
    "description": "{clientName} demande des données personnelles vérifiées depuis votre application d'identité. Consultez les détails ci-dessous et approuvez ou refusez cette demande dans votre application d'identité.",
    "issuanceDescription": "{clientName} ajoute des données vérifiées à votre application d'identité. Consultez les détails ci-dessous et confirmez dans votre application d'identité si vous souhaitez les accepter.",
    "authenticationDescription": "{clientName} souhaite s'authentifier avec votre application d'identité.",
    "descriptionFallback": "Un service demande des données personnelles vérifiées depuis votre application d'identité. Consultez les détails ci-dessous et approuvez ou refusez cette demande dans votre application d'identité.",
    "issuanceDescriptionFallback": "Un service ajoute des données vérifiées à votre application d'identité. Consultez les détails ci-dessous et confirmez dans votre application d'identité si vous souhaitez les accepter.",
    "authenticationDescriptionFallback": "Un service souhaite s'authentifier avec votre application d'identité.",
    "stepsTitle": "Étapes à compléter",
    "stepShareData": "Partager les données avec {clientName}",
    "stepAuthenticate": "S'authentifier pour {clientName}",
    "stepReceiveData": "Recevoir les données de {clientName}",
    "stepGeneric": "Compléter les étapes requises",
    "defaultClientName": "le service",
    "requestedDataTitle": "Les données suivantes sont demandées",
    "issuedDataTitle": "Les données suivantes seront émises",
    "reviewNotice": "Vous examinerez et approuverez les données exactes dans votre application d'identité avant que quoi que ce soit ne soit partagé.",
    "issuanceReviewNotice": "Vous examinerez et approuverez les données exactes dans votre application d'identité avant que quoi que ce soit ne soit ajouté.",
    "indeterminateHint": "Les données demandées seront visibles après avoir sélectionné une application d'identité",
    "terms": "Conditions",
    "termsLink": "Conditions",
    "privacyLink": "Politique de confidentialité",
    "showAll": "Tout afficher",
    "purposeStatementTitle": "Pourquoi vos données sont nécessaires",
    "retentionPolicyTitle": "Comment vos données sont traitées"
  },
  "footer": {
    "powered": "Propulsé par",
    "terms": "Conditions"
  },
  "topBar": {
    "openMenu": "Ouvrir le menu",
    "closeMenu": "Fermer le menu",
    "help": "Aide",
    "language": "Langue"
  },
  "app": {
    "error": "Erreur",
    "loadingTitle": "Chargement en cours",
    "loadingHint": "Un instant"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Rechercher",
    "noResults": "Aucun résultat"
  },
  "init": {
    "title": "Traitement de la demande",
    "hint": "Préparation de votre session"
  },
  "pairing": {
    "title": "Préparation de l'étape suivante",
    "hint": "Préparation de votre session",
    "codeLabel": "Vérifiez le code suivant dans votre application d'identité",
    "confirm": "Confirmer l'appairage"
  },
  "waitingForPresentation": {
    "title": "Continuez dans votre application d'identité",
    "hint": "Veuillez vérifier votre application d'identité pour examiner et approuver la demande"
  },
  "agentStart": {
    "title": "Continuer dans {appName}",
    "subtitle": "Pour partager vos données en toute sécurité, scannez ce code QR avec {appName} pour examiner et approuver la demande.",
    "issuanceSubtitle": "Pour recevoir les données en toute sécurité, scannez ce code QR avec {appName} pour examiner et approuver la demande.",
    "step1": "Ouvrir {appName}",
    "step2": "Cliquer sur l'icône du scanner",
    "step3": "Scanner ce code QR",
    "changeApp": "Changer d'application d'identité",
    "installInstructions": "Instructions d'installation",
    "cancel": "Annuler",
    "needHelp": "Besoin d'aide ?",
    "redirectSubtitle": "Cliquez sur le bouton ci-dessous pour ouvrir {appName} et approuver la demande.",
    "issuanceRedirectSubtitle": "Cliquez sur le bouton ci-dessous pour ouvrir {appName} et approuver la demande.",
    "redirectButton": "Continuer",
    "mobileSubtitle": "Pour partager vos données en toute sécurité, continuez dans {appName} pour examiner et approuver la demande.",
    "issuanceMobileSubtitle": "Pour recevoir les données en toute sécurité, continuez dans {appName} pour examiner et approuver la demande.",
    "openApp": "Ouvrir {appName}",
    "showQr": "Afficher le code QR"
  },
  "done": {
    "disclosure": {
      "title": "Les données ont été partagées avec succès",
      "subtitle": "La page se fermera automatiquement dans quelques secondes.",
      "subtitleCloseTab": "Données partagées avec succès. Vous pouvez fermer cette page."
    },
    "issuance": {
      "title": "Données reçues avec succès",
      "subtitle": "La page se fermera automatiquement dans quelques secondes.",
      "subtitleCloseTab": "Données reçues avec succès. Vous pouvez fermer cette page."
    },
    "redirecting": "Redirection...",
    "completeRedirect": "Terminer et rediriger",
    "redirectFailed": "La redirection automatique n'a pas fonctionné. Appuyez ci-dessous pour continuer."
  },
  "abort": {
    "cancel": {
      "title": "Processus arrêté",
      "subtitle": "Vous avez choisi d'arrêter le processus. Vous pouvez recommencer à tout moment."
    },
    "techFail": {
      "title": "Une erreur s'est produite",
      "subtitle": "Nous n'avons pas pu terminer le processus en raison d'un problème technique."
    },
    "timeout": {
      "title": "Session expirée",
      "subtitle": "Cette session a pris fin après une période d'inactivité. Pour continuer, fermez cette page et redémarrez le processus."
    },
    "networkLoss": {
      "title": "Connexion perdue",
      "subtitle": "Votre connexion Internet a été interrompue. Veuillez vérifier votre connexion et réessayer."
    },
    "backendDowntime": {
      "title": "Service temporairement indisponible",
      "subtitle": "Le service est actuellement en maintenance. Veuillez réessayer plus tard."
    },
    "appUnavailable": {
      "title": "Application d'identité indisponible",
      "subtitle": "Nous n'avons pas pu nous connecter à l'application d'identité sélectionnée. L'application est peut-être temporairement indisponible. Vous pouvez essayer une autre application d'identité ou réessayer plus tard."
    },
    "selectDifferentApp": "Sélectionner une autre application d'identité",
    "confirmTitle": "Arrêter le processus ?",
    "confirmMessage": "Êtes-vous sûr de vouloir arrêter ? Vous pouvez recommencer à tout moment si vous souhaitez continuer plus tard.",
    "confirmCancel": "Annuler",
    "confirmStop": "Arrêter le processus",
    "goBack": "Retour",
    "leave": "Quitter",
    "closePage": "Fermer la page",
    "restart": "Redémarrer",
    "retry": "Réessayer"
  },
  "appPicker": {
    "title": "Applications d'identité prises en charge",
    "subtitle": "Les applications d'identité suivantes peuvent être utilisées pour examiner et approuver la demande",
    "searchPlaceholder": "Rechercher...",
    "sectionLastUsed": "Dernière utilisation",
    "sectionRecommended": "Recommandé",
    "sectionAZ": "A-Z",
    "noResults": "Aucune application ne correspond à votre recherche",
    "filterTitle": "Filtrer par pays",
    "filterClear": "Tout effacer",
    "filterDone": "Terminé"
  },
  "faq": {
    "helpQuestion": "Question",
    "moreHelp": "Plus d'aide",
    "close": "Fermer",
    "whatAreWallets": {
      "title": "Qu'est-ce que les applications d'identité ?",
      "body": "Avec une application d'identité, vous êtes responsable de vos propres données — vous seul décidez quelles données vous partagez, avec qui et quand. Vos données sont récupérées auprès d'un émetteur fiable et vérifié, puis placées dans l'application avec une signature numérique garantissant leur exactitude.\n\nLorsque vous partagez vos données avec un tiers, la signature numérique est incluse afin que la partie prenante puisse en vérifier l'authenticité. Vos données sont généralement stockées uniquement sur votre propre téléphone et peuvent facilement être récupérées si nécessaire.\n\nSoyez toujours conscient que c'est votre responsabilité de choisir avec soin avec qui vous partagez vos données."
    },
    "whyNotSupported": {
      "title": "Pourquoi mon application d'identité n'est-elle pas supportée ?",
      "body": "Il peut arriver que votre application d'identité ne soit pas disponible car la partie destinataire ou notre plateforme ne la supporte pas actuellement. Nous travaillons constamment à élargir notre gamme d'applications supportées.\n\nSi votre application n'est pas répertoriée, vous pouvez toujours installer et utiliser une des autres applications d'identité supportées."
    },
    "howDataProtected": {
      "title": "Comment mes données sont-elles protégées ?",
      "body": "Les applications d'identité garantissent que vous avez toujours le contrôle sur qui vous partagez vos données et quand. Ces applications vous fournissent généralement un aperçu des données partagées, avec qui et quand.\n\nVer.iD envoie vos données directement à la partie prenante et vérifie uniquement qu'elles ont été correctement livrées. Toutes les données sont traitées conformément au Règlement Général sur la Protection des Données (RGPD). La partie prenante applique ensuite ses propres règles de protection et communiquera cela avec vous.\n\nSoyez toujours conscient que c'est votre responsabilité de choisir avec soin avec qui vous partagez vos données."
    },
    "howObtainData": {
      "title": "Comment puis-je ajouter des données dans mon application ?",
      "body": "Chaque application d'identité a sa propre manière de collecter des données. La plupart des applications ont un bouton qui vous permet d'ajouter des données. Dans certains cas, des coûts peuvent s'appliquer.\n\nSuivez les instructions de l'application pour collecter vos données en toute sécurité. Vous pouvez être redirigé vers des sites web gouvernementaux ou être tenu de scanner des documents comme des passeports ou des permis de conduire.\n\nSi vous ne voyez pas de moyen direct d'ajouter les données correctes, consultez la documentation de l'application ou contactez le fournisseur. Vous pouvez aussi essayer une autre application d'identité."
    },
    "whyRedirection": {
      "title": "Pourquoi suis-je redirigé ?",
      "body": "Certaines applications d'identité nécessitent une redirection vers leur propre site web afin que vos données soient partagées conformément à leurs normes, dans un environnement que vous connaissez.\n\nAprès un partage réussi, vous serez automatiquement redirigé vers Ver.iD, où vos données attendront votre confirmation avant d'être envoyées à la partie prenante. Un reçu numérique se trouve généralement dans votre application d'identité.\n\nSi le processus échoue ou est annulé, vous serez également redirigé et pourrez réessayer."
    }
  },
  "dataReview": {
    "title": "Veuillez examiner les données",
    "subtitleDisclosure": "Avant de partager, prenez un moment pour examiner les données qui seront partagées avec {clientName}.",
    "subtitleIssuance": "Avant d'accepter, prenez un moment pour examiner les données que vous recevrez de {clientName}.",
    "issuedBy": "Données émises par",
    "attribute": "Attribut",
    "value": "Valeur",
    "cancel": "Annuler",
    "acceptShare": "Accepter",
    "acceptReceive": "Accepter",
    "unknownClient": "le service",
    "loadingNames": "Chargement des noms de données...",
    "errorLoadingNames": "Impossible de charger les noms de données. Veuillez réessayer."
  },
  "mobileFlowStart": {
    "startVerification": "Continuer",
    "selectApp": "Sélectionner une application d'identité"
  },
  "requestedDataModal": {
    "title": "Données demandées",
    "subtitle": "Vous examinerez et approuverez cette demande dans votre application d'identité.",
    "attribute": "Attribut",
    "description": "Description",
    "issuedBy": "Données émises par",
    "close": "Fermer"
  },
  "demo": {
    "title": "Environnement de démonstration",
    "description": "Vous utilisez une démonstration interactive de Ver.iD. Cet environnement est destiné uniquement à des fins de démonstration."
  },
  "installInstructions": {
    "title": "Installer {appName}",
    "subtitle": "Rendez-vous sur l'App Store ou le Play Store de votre téléphone pour installer l'application d'identité {appName}. Scannez le code pour ouvrir directement la page du store et installer l'application.",
    "close": "Fermer",
    "unavailableTitle": "Instructions non disponibles",
    "unavailableBody": "Désolé, nous n'avons pas d'instructions d'installation disponibles pour cette application pour le moment. Essayez de rechercher manuellement l'application dans le store pour continuer."
  }
}
